<template>
    <v-container class="fill-height" fluid>
        <v-row>
            <v-col cols="12" class="text-center">
                <v-col cols="12">
                    <v-progress-circular indeterminate color="primary" />
                </v-col>
                <v-col cols="12"> Please wait... </v-col>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'LoadingPage',
    layout: 'full-canvas',
};
</script>
